export var Name = 'download-file';
export var DownloadFile = Name;